import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {HeroBanner} from '../../../../../models/page-content';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

declare var jscolor: any;
declare var $: any;
const CONSOLE_PREFIX = 'hero banners form';

// noinspection DuplicatedCode
@Component({
  selector: 'app-hero-banner-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './hero-banner-form.component.html',
})
export class HeroBannerFormComponent implements OnInit, OnChanges {
  heroBannerForm: FormGroup;
  @Input() initialData: HeroBanner[];

  constructor(private fb: FormBuilder) {
  }

  async ngOnInit(): Promise<void> {
    this.heroBannerForm = this.fb.group({
      // heroBanners: this.fb.array([this.createHeroBanner('ngOnInit')])
      heroBanners: this.fb.array([])
    });
    await this.loadResources();
  }

  async loadResources() {
  }

  populateForm(data: HeroBanner[]): void {

    console.log(CONSOLE_PREFIX + '(populateForm) - data', data);
    console.log(CONSOLE_PREFIX + '(populateForm) - heroBanners', this.heroBanners);
    console.log(CONSOLE_PREFIX + '(populateForm) - heroBanners.length', this.heroBanners.length);

    while (this.heroBanners && this.heroBanners.length !== 0) {
      this.heroBanners.removeAt(0);
    }

    setTimeout(() => {
      // Populate the form array with new data
      console.log(CONSOLE_PREFIX + '(populateForm) - data', data);
      data.forEach(bannerData => {
        console.log(CONSOLE_PREFIX + '(populateForm) - bannerData', bannerData);
        if (bannerData.imageUrl) {
          console.log(CONSOLE_PREFIX + '(populateForm) - populating bannerData', bannerData);
          this.heroBanners.push(this.createHeroBanner('populateForm', bannerData));
        }
      });
    }, 1000);
  }

  createHeroBanner(referrer, data: any = {}): FormGroup {
    console.log(CONSOLE_PREFIX + '(createHeroBanner) - referrer', referrer);
    setTimeout(() => {
      jscolor.install(); // recognizes new inputs and installs jscolor on them
      console.log(CONSOLE_PREFIX + '(createHeroBanner) - jscolor install', jscolor.install);

      setTimeout(() => {
        let size = this.heroBanners.length;
        console.log(CONSOLE_PREFIX + '(addHeroBanner) - size', size);
        let tabId = '#myTab #header_' + (size - 1);
        console.log(CONSOLE_PREFIX + '(addHeroBanner) - tabId', tabId);
        let tab = $(tabId);
        console.log(CONSOLE_PREFIX + '(addHeroBanner) - tab show', tab);
        tab.tab('show');
      }, 100);
    }, 500);

    console.log(CONSOLE_PREFIX + '(createHeroBanner) - data', data);
    return this.fb.group({
      imageUrl: [data.imageUrl || '', Validators.required],
      headline: [data.headline || ''],
      headline_ar: [data.headline_locale != null && data.headline_locale.ar != null ? data.headline_locale.ar : ''],
      subHeadline: [data.subHeadline || ''],
      subHeadline_ar: [data.subHeadline_locale != null && data.subHeadline_locale.ar != null ? data.subHeadline_locale.ar : ''],
      headlineColor: [data.headlineColor || '#FFFFFFFF'],
      subHeadLineColor: [data.subHeadLineColor || '#FFFFFFFF'],
      backgroundColor: [data.backgroundColor || '#FFFFFFFF']
    });
  }

  ngAfterViewInit() {
    jscolor.init();
    console.log(CONSOLE_PREFIX + '(ngAfterViewInit) - jscolor init', jscolor.init);
  }

  // @ts-ignore
  get heroBanners(): FormArray {
    // @ts-ignore
    return this.heroBannerForm != null && this.heroBannerForm.get('heroBanners') != null ? this.heroBannerForm.get('heroBanners') as FormArray : [];
  }

  async addHeroBanner(): Promise<void> {
    this.heroBanners.push(this.createHeroBanner('addHeroBanner event'));
  }

  removeHeroBanner(index: number): void {
    this.heroBanners.removeAt(index);
    setTimeout(() => {
      // choose the current index, if the index is bigger than the size, then choose the last item.
      let size = this.heroBanners.length;
      let newIndex = index >= size ? size - 1 : index;
      let tabId = '#myTab #header_' + newIndex;
      let tab = $(tabId);
      tab.tab('show');
    }, 100);
  }

  onSubmit(): void {
    if (this.heroBannerForm.valid) {
      console.log(CONSOLE_PREFIX + '(onSubmit) - this.heroBannerForm.value', this.heroBannerForm.value);
    }
  }

  ngAfterViewChecked(): void {
    // This code will be executed after every check of the component's view.
    // Be careful with triggering additional change detection cycles within this hook.
    // console.log(CONSOLE_PREFIX + '(ngAfterViewChecked) - heroBanners', this.heroBanners);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(CONSOLE_PREFIX + '(ngOnChanges) - changes', changes);
    if (changes.initialData) {
      this.populateForm(changes.initialData.currentValue);
    }
  }
}
